import {
  UGCDataActionTypes,
  ISnapData,
  SET_SNAP_DATA,
  UPDATE_HASDATA,
  UPDATE_HASREVIEWDATA,
  UPDATE_HAS_QNADATA,
  SET_USER_REVIEWS,
  UPDATE_REVIEW_DETAILS,
  UPDATE_QNA_DETAILS,
  UPDATE_PAGINATOR_STATUS,
  UPDATE_QNAPAGINATOR_STATUS,
  SET_QNA_FILTER,
  SET_QNA_DATA,
  UPDATE_QNA_TAGS,
  UPDATE_NEW_QUESTIONS,
  QNADataType,
  GIDataType,
  SnapDataType,
  ReviewDataList,
  SET_REVIEW_DATA_STATUS,
  SET_QNA_DATA_STATUS,
  SET_MORE_IMAGES,
  UPDATE_HAS_MOREIMAGES,
  SELECTED_RNR_TYPE,
  UPDATE_RNR_TAGS,
} from './types';

import {
  DEFAULT_RNR_SORTBY,
  DEFAULT_RNR_LIMIT,
  DEFAULT_RNR_OFFSET,
  DEFAULT_QNA_LIMIT,
  DEFAULT_QNA_OFFSET,
} from '../ugc_config.js';

const initialState: ISnapData = {
  snapData: {} as SnapDataType,
  hasData: null,
  pendingReviewData: true,
  reviewData: {} as ReviewDataList,
  hasReviewData: null,
  reviewDetailType: {
    offset: DEFAULT_RNR_OFFSET,
    limit: DEFAULT_RNR_LIMIT,
    tagIds: [],
    filter: '',
    sortBy: DEFAULT_RNR_SORTBY,
    page: 1,
  },
  qnaDetailType: {
    offset: DEFAULT_QNA_OFFSET,
    limit: DEFAULT_QNA_LIMIT,
    filter: [],
    sortBy: '',
  },
  paginatorStatus: ['default'],
  qnaPaginatorStatus: ['default'],
  qnaFilterData: [],
  hasQnaData: null,
  pendingQnaData: true,
  qnaData: {} as QNADataType,
  selTagIds: [],
  selRnrTagIds: [],
  newQuestions: [],
  moreUgcImages: [],
  hasMoreImages: null,
  selectedRnRType: '',
};

export default function ugcReducer(state = initialState, action: UGCDataActionTypes) {
  switch (action.type) {
    case SET_SNAP_DATA:
      return {
        ...state,
        snapData: action.actionData,
      };

    case UPDATE_HASDATA:
      return {
        ...state,
        hasData: action.actionData,
      };

    case UPDATE_HASREVIEWDATA:
      return {
        ...state,
        hasReviewData: action.actionData,
      };

    case UPDATE_HAS_QNADATA:
      return {
        ...state,
        hasQnaData: action.actionData,
      };

    case SET_USER_REVIEWS:
      return {
        ...state,
        reviewData: action.actionData,
      };

    case UPDATE_REVIEW_DETAILS:
      return {
        ...state,
        reviewDetailType: {...state.reviewDetailType, ...action.actionData},
      };

    case UPDATE_QNA_DETAILS:
      return {
        ...state,
        qnaDetailType: action.actionData,
      };

    case UPDATE_PAGINATOR_STATUS:
      return {
        ...state,
        paginatorStatus: action.actionData,
      };

    case UPDATE_QNAPAGINATOR_STATUS:
      return {
        ...state,
        qnaPaginatorStatus: action.actionData,
      };

    case SET_QNA_FILTER:
      return {
        ...state,
        qnaFilterData: action.actionData,
      };

    case SET_QNA_DATA:
      return {
        ...state,
        qnaData: action.actionData,
      };

    case UPDATE_QNA_TAGS:
      return {
        ...state,
        selTagIds: action.actionData,
      };

    case UPDATE_RNR_TAGS:
      return {
        ...state,
        selRnrTagIds: action.actionData,
      };

    case UPDATE_NEW_QUESTIONS:
      return {
        ...state,
        newQuestions: action.actionData,
      };

    case SET_REVIEW_DATA_STATUS:
      return {
        ...state,
        pendingReviewData: action.actionData,
      };

    case SET_QNA_DATA_STATUS:
      return {
        ...state,
        pendingQnaData: action.actionData,
      };

    case SET_MORE_IMAGES:
      return {
        ...state,
        moreUgcImages: action.actionData,
      };

    case UPDATE_HAS_MOREIMAGES:
      return {
        ...state,
        hasMoreImages: action.actionData,
      };

    case SELECTED_RNR_TYPE:
      return {
        ...state,
        selectedRnRType: action.actionData,
      };

    default:
      return state;
  }
}
